var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserScreenDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34314 1.34315 0 3 0H20V33H3C1.34315 33 0 31.6569 0 30V3Z",
    fill: "#D4DDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H20V6H0V3Z",
    fill: "#3C3666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6531 0H21V33H38.9592C40.5918 33 41 31.6667 41 31V9L33.6531 0Z",
    fill: "#518FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7.5V0H33.5L41 9H33C31.8 9 31.1667 8 31 7.5Z",
    fill: "#A6C5FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#B4C2D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 2,
    height: 1,
    fill: "#E23750"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 2,
    height: 1,
    fill: "#58EDC2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 5,
    height: 1,
    fill: "#27223F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#B4C2D6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#B4C2D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#23B0E2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#23B0E2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 16,
    width: 11,
    height: 1,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    width: 11,
    height: 1,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22,
    width: 11,
    height: 1,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 7,
    height: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserScreenDocument);
export default __webpack_public_path__ + "static/media/UserScreenDocument.c5f40b0c06d6769f88ca8ca452221149.svg";
export { ForwardRef as ReactComponent };